import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { RfpProfessionalRequiredConditionPossibleGroupTag } from '@/components/modules/pages/rfp/professional/Tag/RfpProfessionalRequiredConditionPossibleGroupTag';
import { RFP_REQUIRED_CONDITION_BUDGET_POLICIES } from '@/utils/constants/rfp/rfpRequiredCondition/budgetPolicy';
/**
 * 「プロジェクトで求めていること」で利用する予算方針タグ
 * @param props
 * @constructor
 */
export const RfpProfessionalRequiredConditionBudgetPolicyPossibleGroupTag = (props) => {
    const { budgetPolicy, className = '' } = props;
    const items = useMemo(() => RFP_REQUIRED_CONDITION_BUDGET_POLICIES.map((v) => ({
        isPossible: v.value === budgetPolicy,
        label: v.label,
    })), [budgetPolicy]);
    return (_jsx(RfpProfessionalRequiredConditionPossibleGroupTag, { className: className, items: items }));
};
